import { DebugPanel, Flippable } from "../components/debugPanel";

export function OrgDebugPanel() {
    return (
        <Flippable feature="showFeatureFlipper">
            <DebugPanel />
        </Flippable>
    );
}
